module.exports = __webpack_public_path__ + "../resources/images/illustration_trash-25bf184b26aec326f86baebe8bfd024a.svg";